module.exports = __webpack_public_path__ + "img/paynow.edd50e4.png";